import { ReplyCommentModel } from '../../../shared/data/models/reply-comment.model';

export interface ReplyCommentState {
  comment: ReplyCommentModel;
}

export const initialReplyCommentState: ReplyCommentState = {
  comment: null
};
